import { jsx as _jsx } from "react/jsx-runtime";
import { formatDate } from "@madmedical/utils";
import { Box } from "native-base";
import { useTranslation } from "@madmedical/i18n";
import { usePreOp } from "../../providers/preop";
import { useRouteNavigate } from "../../providers/routing";
import Alert from "../../molecules/Alert";
import { useCurrentPatient } from "../../providers/currentPatient";
const PreOpAlert = () => {
    const { questionnaire } = usePreOp();
    const { patient } = useCurrentPatient();
    const navigate = useRouteNavigate();
    const { t } = useTranslation();
    if (!questionnaire) {
        return null;
    }
    return (_jsx(Box, Object.assign({ mb: 3 }, { children: _jsx(Alert, { title: "Altat\u00E1si k\u00E9rd\u0151\u00EDv", description: `${questionnaire.badAnswersCount} figyelmeztetés ${patient.fullName} által kitöltött „Altatási kérdőív” dokumentummal kapcsolatban. (${formatDate(questionnaire.createdAt)})`, links: [
                {
                    text: t("view"),
                    onPress: () => {
                        navigate("preop", { patientId: patient.userId });
                    },
                },
            ], status: questionnaire.badAnswersCount ? "error" : "success" }) })));
};
export default PreOpAlert;
